import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA support (production only).
// Auto-reload the tab the first time a brand-new SW takes control — this
// unsticks users whose cached bundle is pointing at a retired backend.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    // Only reload when we already had a controller (i.e. SW just swapped)
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}
